import React, { useEffect } from 'react'
import { useShopStoreIncontext } from '../../context/shopContext'
import { buildInstantCollectionData } from '../../helpers/instantDataTransformers'

function retryInstant(query, timout) {
  try {
    query()
  } catch (err) {
    if (!window.location.href.includes('uk')) {
      setTimeout(() => retryInstant(query, timout), timout)
    }
  }
}

function retryLearnQ(query, timout) {
  try {
    query()
  } catch (err) {
    if (!window.location.href.includes('uk')) {
      setTimeout(() => retryLearnQ(query, timout), timout)
    }
  }
}

const InstantCollectionTracking = ({ data }) => {
  const { analytics } = useShopStoreIncontext((state) => {
    return {
      analytics: state.analytics,
    }
  })

  useEffect(() => {
    analytics.track('Product List Viewed', {
      list_id: data.CollectionName,
      category: data.CollectionName,
      url: window.location.href,
    });

    retryInstant(() => {
      const collection = {
        CollectionName: data.CollectionName,
        CollectionURL: window.location.href,
      }

      window.InstantJS.track('COLLECTION_VIEWED', [
        {
          provider: 'KLAVIYO',
          event: collection,
        },
        {
          provider: 'INSTANT',
          event: buildInstantCollectionData(data.products || [])
        }
      ])
    })

    var _learnq = window._learnq || []

    retryLearnQ(() => {
      const collection = {
        CollectionName: data.CollectionName,
        CollectionURL: window.location.href,
      }

      _learnq.push(['track', 'Viewed Collection', collection])
    }, 3000)
  }, [data.CollectionName])
  return <></>
}

export default InstantCollectionTracking
